import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { ISetting } from './../../../_models/cms/ISetting';
import { SettingService } from './../../../shared/services/setting.service';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { IPaged } from './../../../_models/common/IPaged';
import { IProfile } from './../../../_models/account/IProfile';
import { ProfileService } from './../../../shared/services/profile.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  loading: boolean;
  skeleton: boolean = true;
  profile: IProfile;
  private readonly PAGE_SIZE = 10;
financialyearId: any;
  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending'
  };

  columns = [
    { title: 'App No.', key: 'Id', isSortable: true },
    { title: 'Year', key: 'FinancialYearId', isSortable: true },
    { title: 'Phase', key: 'PhaseId', isSortable: true },
    { title: 'APPLIED for transfer?', key: 'IsTransfer', isSortable: true },
    {},
    {}
  ];

  setting: ISetting;
  constructor(
    private profileService: ProfileService,
    private service: TransferRequestService,
    private settingService: SettingService) { }

  async ngOnInit() {
    this.setting = await this.settingService.getSetting();
    this.financialyearId = this.setting.financialYearId;
    this.getProfile();
    this.populateTransferRequests();
  }

  private getProfile() {
    this.profileService.logged().subscribe((response: IProfile) => {
      if (response) {
        this.profile = response;
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }

  private populateTransferRequests() {
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }

  print(id) {
    this.service.print(id).subscribe((data) => {
      const blob = new Blob([data], { type: 'application/pdf' });
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "print.pdf";
      link.click();
    });
  }

  isResultButtonDisplay(v: ITransferRequest): boolean {
    return this.setting ? v.financialYearId == this.setting.financialYearId && v.phaseId == 1 : false;
  }


  isConfirmButtonDisplay(v: ITransferRequest): boolean { 
    return this.setting ? v.financialYearId == this.setting.financialYearId && v.phaseId == this.setting.phaseId : false;
  }
}
